import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./Layout";
import Home from "./pages/Home";
import Go from "./pages/Go";
import LoginPage from "./pages/LoginPage";
import Register from "./pages/Register";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CompleteProfile from "./pages/CompleteProfile";
import ChangeMobile from "./pages/ChangeMobile";
import Washes from "./pages/Washes";
import PaymentGateway from "./pages/PaymentGateway";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";
import PaymentCallbackSimple from "./pages/PaymentCallbackSimple";
import ChangePassword from "./pages/ChangePassword";
import Services from "./pages/Services";
import TermsPage from "./pages/Terms";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="go" element={<Go />} />
            <Route path="washes" element={<Washes />} />
            <Route path="services" element={<Services />} />
            <Route path="/payment" element={<PaymentGateway />} />
            <Route path="payment-success" element={<PaymentSuccess />} />
            <Route path="payment-failed" element={<PaymentFailed />} />
            <Route path="/payment/call_back_res" element={<PaymentCallbackSimple />} />
                      <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<Register />} />
          <Route path="update" element={<CompleteProfile />} />
          <Route path="update-mobile" element={<ChangeMobile />} />
          <Route path="forget-password" element={<ChangePassword />} />
          <Route path="terms" element={<TermsPage />} />
          </Route>

        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
